module.exports = __webpack_public_path__ + "static/media/toc.d058d6f6.png";